


  import api from '@/api/backend-api'; //global css

  import {defineComponent} from 'vue';
  import InformationComponent from "@/components/shared/InformationComponent.vue";
  import {Item} from "@/domain/ui/Item";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters} from "vuex";
  import store from "@/store";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import router from "@/router";
  import paycoUtils from "@/assets/js/utils";
  import ComplexPayment from "@/domain/order/ComplexPayment";
  import Ticket from "@/domain/ticket/Ticket";

  export default defineComponent({
    name: 'PaymentCancellationHistoryView',
    components: {
      HeaderComponent,
      InformationComponent
    },
    props: [
        'ticketId',
        'orderId'
    ],
    data() {
      return {
        paymentCancellationHistory: [] as Array<Item>,
        complexAspSaveAmount: 0,
        complexAspPayAmount: 0,
        orderCancelAmount: 0,
        paymentCancelAmount: 0,
        orderCancelYmdt: '2020.01.01 00:00:00',
        orderCancelType: '',
      }
    },
    computed: {
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    mounted() {
      if (this.ticketId != undefined) {
        this.getTicketCancellationHistory(this.ticketId);
      } else if (this.orderId != undefined) {
        this.getOrderCancellationHistory();
      }
    },
    methods: {
      getTicketCancellationHistory(ticketId: string): void {
        api.getCancellationHistory(ticketId)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('PaymentCancellationHistoryView', {orderId: this.ticketId}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          response.data.result.complexPayments.forEach((complexPayment: ComplexPayment) => {
            switch (complexPayment.paymentMethod) {
              case 'ASP_MEMBERSHIP_SAVE':
                this.complexAspSaveAmount += complexPayment.paymentAmount;
                break;
              case 'ASP_MEMBERSHIP_PAY':
                this.complexAspPayAmount += complexPayment.paymentAmount;
                break;
            }
          });

          this.orderCancelYmdt = response.data.result.cancelYmdt > this.orderCancelYmdt ? response.data.result.cancelYmdt : this.orderCancelYmdt;
          this.orderCancelAmount += response.data.result.orderCancelAmount;
          this.paymentCancelAmount += response.data.result.paymentCancelAmount;
          this.orderCancelType = response.data.result.orderCancelType;

          this.setCancellationDetail();
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },

      getOrderCancellationHistory(): void {
        api.getOrderDetail(this.orderId)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('PaymentCancellationHistoryView', {orderId: this.ticketId}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          response.data.result.ticketList.forEach((ticket: Ticket) => {
            if(ticket.ticketStatus === 'CANCEL') {
              this.getTicketCancellationHistory(ticket.ticketId);
            }
          });
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },

      orderCancelTypeString(orderCancelType: string): string {
        return orderCancelType === 'TICKET' ? '부분 취소' : '전체 취소';
      },

      setCancellationDetail(): void {
        this.paymentCancellationHistory.splice(0, this.paymentCancellationHistory.length);
        this.paymentCancellationHistory.push(new Item('결제 취소일', this.orderCancelYmdt));
        this.paymentCancellationHistory.push(new Item('주문 취소 금액', paycoUtils.numWithCommas(this.orderCancelAmount) + '원'));
        if (this.complexAspSaveAmount > 0) {
          this.paymentCancellationHistory.push(new Item('포인트 사용', '- ' + paycoUtils.numWithCommas(this.complexAspSaveAmount) + '원'));
        }
        if (this.complexAspPayAmount > 0) {
          this.paymentCancellationHistory.push(new Item('충전금 사용', '- ' + paycoUtils.numWithCommas(this.complexAspPayAmount) + '원'));
        }
        this.paymentCancellationHistory.push(new Item('결제 취소 금액', paycoUtils.numWithCommas(this.paymentCancelAmount) + '원'));
        this.paymentCancellationHistory.push(new Item('결제 상태', this.orderCancelTypeString(this.orderCancelType)));
      }
    }
  });

